const designWidth = 2560;

const basFontSize = 100

export const setRem = function(){
    const clientWidth = document.documentElement.clientWidth;
    const minWidth = 1200;
    const maxWidth = 2560;
    const width = Math.max(minWidth, Math.min(clientWidth, maxWidth));
    const scale = width / designWidth;
    document.documentElement.style.fontSize = basFontSize *  scale + 'px';
}